import instanceQuery from '../../queries/product/AllocationQuery.graphql';
import fragment from '../../fragments/product/AllocationFragment.graphql';
import workspaceQuery from '../../queries/product/ProductAllocationWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const Allocation: EntityType = {
  type: 'Allocation',
  title: 'Allocations',
  formTitle: 'Allocation',
  formUrl: '/Product/Allocation/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  fragment,
  workspaceUrl: '/Products/Allocation/Workspace/',
  screenReference: 'SALES_PRODUCT_ALLOCATION',
};

export default Allocation;
